module.exports = __webpack_public_path__ + "static/media/badge6.de5eb0ba.svg";